import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["getFields", "getSections", "getWarnings"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint implicit-arrow-linebreak: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _values from 'lodash/values';
import _pick from 'lodash/pick';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Handlers
import ACTION_HANDLERS from './withFormPageState.handlers';
var withFormPageState = function withFormPageState() {
  var TABLE_ACTION_HANDLERS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var customActionHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
  return function wrapComponent(WrappedComponent) {
    var WithFormPageState = /*#__PURE__*/function (_Component) {
      _inherits(WithFormPageState, _Component);
      var _super = _createSuper(WithFormPageState);
      function WithFormPageState(props) {
        var _this;
        _classCallCheck(this, WithFormPageState);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "getState", function () {
          var _this$props = _this.props,
            getFields = _this$props.getFields,
            getSections = _this$props.getSections,
            getWarnings = _this$props.getWarnings,
            restProps = _objectWithoutProperties(_this$props, _excluded);
          return _objectSpread(_objectSpread(_objectSpread({}, restProps), _this.state), {}, {
            onAction: _this.handleAction
          });
        });
        _defineProperty(_assertThisInitialized(_this), "reinitializeForm", function () {
          var initialValues = _this.props.initialValues;
          _this.setState({
            values: initialValues
          });
        });
        _defineProperty(_assertThisInitialized(_this), "handleCellAction", function () {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
          var mapFieldToOnChange = _this.props.mapFieldToOnChange;
          var handler = _this.actionHandlers[action.type];
          if (handler) {
            handler({
              params: action.payload,
              getState: _this.getState,
              setState: _this.setState.bind(_assertThisInitialized(_this)),
              mapFieldToOnChange: mapFieldToOnChange
            });
          }
        });
        _defineProperty(_assertThisInitialized(_this), "handleTableAction", function () {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
          var handler = TABLE_ACTION_HANDLERS[action.type];
          if (handler) {
            handler({
              getState: _this.getState,
              setState: _this.setState.bind(_assertThisInitialized(_this)),
              params: action.payload
            });
          }
        });
        _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
          var columnId = _get(action, 'payload.columnId');
          if (columnId === 'action') {
            _this.handleTableAction(action);
          }
          _this.handleCellAction(action);
        });
        _this.state = _objectSpread(_objectSpread({}, initialState), {}, {
          values: props.initialValues || EMPTY_OBJECT,
          errors: EMPTY_OBJECT
        });
        _this.actionHandlers = _objectSpread(_objectSpread(_objectSpread({}, ACTION_HANDLERS), customActionHandlers), props.additionalActionHandlers);
        return _this;
      }
      _createClass(WithFormPageState, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var initialValues = this.props.initialValues;
          var prevInitialValues = prevProps.initialValues;
          if (initialValues !== prevInitialValues) {
            this.reinitializeForm();
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
            getFields = _this$props2.getFields,
            getSections = _this$props2.getSections,
            getWarnings = _this$props2.getWarnings,
            useKeyBoardShortcuts = _this$props2.useKeyBoardShortcuts,
            initialValues = _this$props2.initialValues,
            formConfigDependantKeys = _this$props2.formConfigDependantKeys,
            formSectionDependantKeys = _this$props2.formSectionDependantKeys;
          var _this$state = this.state,
            values = _this$state.values,
            errors = _this$state.errors;
          var getStateValues = this.getState();
          var formConfigDependantValues = _values(_pick(getStateValues, formConfigDependantKeys));
          var formSectionDependantValues = _values(_pick(getStateValues, formSectionDependantKeys));
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, getStateValues, {
            initialFormValues: initialValues,
            values: values,
            errors: errors,
            fields: getFields.apply(void 0, _toConsumableArray(formConfigDependantValues)),
            sections: getSections.apply(void 0, _toConsumableArray(formSectionDependantValues)),
            warnings: getWarnings(values),
            onAction: this.handleAction,
            useKeyBoardShortcuts: useKeyBoardShortcuts
          }));
        }
      }]);
      return WithFormPageState;
    }(Component);
    WithFormPageState.propTypes = {
      initialValues: PropTypes.object,
      mapFieldToOnChange: PropTypes.object,
      /**
       * Please make sure that the below 2 methods are default memoized.
       * Moving forward will figure out a way so that everyone is saved from the effort of default memoize.
       */
      getFields: PropTypes.func,
      getSections: PropTypes.func,
      getWarnings: PropTypes.func,
      onSubmit: PropTypes.func,
      onTertiaryAction: PropTypes.func,
      notifyErrors: PropTypes.func,
      additionalActionHandlers: PropTypes.object,
      formConfigDependantKeys: PropTypes.arrayOf(PropTypes.string),
      formSectionDependantKeys: PropTypes.arrayOf(PropTypes.string)
    };
    WithFormPageState.defaultProps = {
      initialValues: EMPTY_OBJECT,
      mapFieldToOnChange: EMPTY_OBJECT,
      getFields: _noop,
      getSections: _noop,
      getWarnings: _noop,
      onSubmit: _noop,
      onTertiaryAction: _noop,
      notifyErrors: _noop,
      additionalActionHandlers: EMPTY_OBJECT,
      formConfigDependantKeys: ['values'],
      formSectionDependantKeys: ['values']
    };
    return WithFormPageState;
  };
};
export default withFormPageState;